import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum } from '@datadog/browser-rum';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Initialize Datadog RUM
datadogRum.init({
  applicationId: '8647ea07-25f7-420f-948a-d8f46e33a1fc',
  clientToken: 'pubfe30b586e6d668826d5ee0740fe1b2a6',
  site: 'datadoghq.eu',
  service: 'explain_app_front',
  env: environment.production ? 'production' : 'staging',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: 'allow',
});

/** Registration to service worker */
platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
  if ('serviceWorker' in navigator && environment.production) {
    navigator.serviceWorker.register('ngsw-worker.js');
  }
}).catch(err => console.log(err));
